(function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get product data
    const product = JSON.parse(section.querySelector(".productJSON").textContent);

    // note, the starting activeVariant is set in the section liquid file, when options are changed we fetch the new variant data from the server
    let activeVariant = JSON.parse(section.querySelector(".productVariantJSON").textContent);
    let quantity = 1;
    const notifiedVariants = new Set();

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /************
     Product Swiper
     ************/

    const swiperMap = new Map(); // variantId -> Swiper instance

    function initSwipers() {
        section.querySelectorAll(".productVisual").forEach(visual => {
            const variantId = parseInt(visual.dataset.id);
            const swiperEl = visual.querySelector(".productVisualSwiper");
            if (!swiperEl) return;

            const swiper = new Swiper(swiperEl, {
                slidesPerView: 1,
                spaceBetween: 0,
                loop: true,
                autoHeight: true,
                on: {
                    slideChange: function () {
                        visual.querySelector(".productVisualThumbsSlide.active")?.classList.remove("active");
                        visual.querySelectorAll(".productVisualThumbsSlide")[this.realIndex]?.classList.add("active");
                    }
                }
            });

            swiperMap.set(variantId, swiper);

            visual.querySelectorAll(".productVisualThumbsSlide").forEach(thumb => {
                thumb.addEventListener("click", function () {
                    swiper.slideTo(parseInt(this.dataset.index) - 1);
                });
            });
        });
    }

    initSwipers();

    function updateVisual() {
        section.querySelectorAll(".productVisual").forEach(visual => {
            visual.classList.toggle("active", parseInt(visual.dataset.id) === activeVariant.id);
        });
    }

    // strip " {n} Pack" from option value labels
    section.querySelectorAll('.productOptionsItemValuesLabelSelector').forEach(el => {
        let text = el.textContent;
        if (product.handle === 'olive-oil-styling-gel-travel-pack') {
            text = text.replace(/\d+oz /g, '');
        }
        el.textContent = text.replace(/ \d+ Pack/g, '');
    });

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct();
        });
    })

    // toggle active class on selling options when radio changes
    section.querySelectorAll(".productSellingOptionHeaderInput").forEach(function (input) {
        input.addEventListener("change", () => {
            section.querySelectorAll(".productSellingOption").forEach(el => el.classList.remove("active"));
            input.closest(".productSellingOption").classList.add("active");
        });
    });

    /**************
     Update Product
     ***************/

    function isSubscription() {
        return !!section.querySelector(`.productSellingOptionHeaderInput[value="sub"]:checked`);
    }

    function currentSellingPlan() {
        return parseInt(section.querySelector('.productSellingOptionPlan').value);
    }

    async function updateProduct() {
        // check if variant wasn't found (null would be returned from the fetch)
        if (!activeVariant) {
            section.querySelector(".productBuyATC").disabled = true;
            section.querySelector(".productBuyATCText").textContent = "Not Available";
            return;
        }

        /**************
         Variant Image
         ***************/

        updateVisual();

        /**************
         Price
         ***************/

        // if there's a subscription we need to update both prices
        if (product.selling_plan_groups.length > 0) {
            // Select both sets of elements at once
            const compares = section.querySelectorAll(".productSellingOptionHeaderPriceCompare");
            const reals = section.querySelectorAll(".productSellingOptionHeaderPriceReal");

            // Destructure them for clarity:
            // Assuming the markup is structured so that index 0 is for subscription, index 1 for one-time purchase
            const [subCompare, oneTimeCompare] = compares;
            const [subReal, oneTimeReal] = reals;

            const allocationPrice = activeVariant.selling_plan_allocations[0].price;

            // Update subscription prices
            if (activeVariant.price > allocationPrice) {
                subCompare.textContent = price(activeVariant.price);
            }
            subReal.textContent = price(allocationPrice);

            // Update one-time purchase prices
            if (activeVariant.compare_at_price > activeVariant.price) {
                oneTimeCompare.textContent = price(activeVariant.compare_at_price);
            }
            oneTimeReal.textContent = price(activeVariant.price);

        } else {
            // Non-subscription scenario
            const realEl = section.querySelector(".productPriceReal");
            const compareEl = section.querySelector(".productPriceCompare");

            if (realEl) realEl.textContent = price(activeVariant.price);
            if (activeVariant.compare_at_price > activeVariant.price) {
                if (compareEl) compareEl.textContent = price(activeVariant.compare_at_price);
            } else if (compareEl) {
                compareEl.textContent = "";
            }
        }

        /**************
         ATC Enable/Disable
         ***************/

            // check if the variant is in stock
        const buySection = section.querySelector(".productBuy");
        const notifySection = section.querySelector(".productNotify");
        const sellingSection = section.querySelector(".productSelling");

        if (activeVariant.available) {
            buySection.style.display = "";
            notifySection.style.display = "none";
            if (sellingSection) sellingSection.style.display = "";
            section.querySelector(".productBuyATC").disabled = false;
            section.querySelector(".productBuyATCText").textContent = "Add to Cart";
        } else {
            buySection.style.display = "none";
            notifySection.style.display = "";
            if (sellingSection) sellingSection.style.display = "none";

            const comingSoon = section.querySelector(`.productVisual[data-id="${activeVariant.id}"]`)?.dataset.comingSoon === 'true';

            if (notifiedVariants.has(activeVariant.id)) {
                notifySection.innerHTML =
                    '<p class="productNotifySuccess">We\'ll notify you when this product is ' + (comingSoon ? 'available!' : 'back in stock!') + '</p>';
            } else {
                const notifyMsg = comingSoon
                    ? activeVariant.title.replace(/ \d+ Pack/g, '') + ' will be available soon. Would you like to be notified when available?'
                    : activeVariant.title.replace(/ \d+ Pack/g, '') + ' is currently out of stock. Would you like to be notified when available?';
                notifySection.innerHTML =
                    '<p class="productNotifyMessage">' + notifyMsg + '</p>' +
                    '<form class="productNotifyForm">' +
                    '<input class="productNotifyFormInput" type="email" name="email" placeholder="Email Address" required>' +
                    '<button class="productNotifyFormSubmit button" type="submit">Submit</button>' +
                    '</form>';
                bindNotifyForm();
            }
        }

        /*************
         Update Sticky
         *********/

            // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct();

    /**************
     Product Quantity
     ***************/

    // minus
    section.querySelector(".productBuyQuantityControlsBtn.minus")?.addEventListener("click", function () {
        if (quantity === 1) {
            return;
        }
        quantity--;
        section.querySelector(".productBuyQuantityControlsValue").textContent = quantity;
        updateProduct();
    });

    // plus
    section.querySelector(".productBuyQuantityControlsBtn.plus")?.addEventListener("click", function () {
        quantity++;
        section.querySelector(".productBuyQuantityControlsValue").textContent = quantity;
        updateProduct();
    });

    // redirect to new url on option change
    section.querySelectorAll(".productOptionsItemValuesLabelInput").forEach(function (element) {
        element.addEventListener("change", async function () {
            // update the label to reflect the newly selected value
            const optionName = element.name.replace(`${sectionID}-`, '');
            const label = element.closest('.productOptionsItem').querySelector('.productOptionsItemLabel');
            if (label) label.textContent = `Choose ${optionName}: ${element.value}`;

            // create array of selected option ids
            const optionIDs = [];
            section.querySelectorAll(".productOptionsItemValuesLabelInput:checked").forEach(element => {
                optionIDs.push(element.dataset.id);
            })

            // fetch updated variant data
            const response = await fetch(`${window.location.pathname}?view=active-variant&option_values=${optionIDs.join(',')}`)
                .then(response => response.json());

            // update active variant
            activeVariant = response.active_variant;

            // update product
            updateProduct();
        });
    })

    /**************
     Product ATC
     ***************/

    async function addToCart() {

        // add loading animation to both buttons
        section.querySelector(".productBuyATC").classList.add("loading");

        let formData = {
            items: [{
                quantity: quantity,
                id: activeVariant.id,
            }]
        };

        // check for selling plan
        if (isSubscription()) {
            formData.items[0].selling_plan = parseInt(section.querySelector('.productSellingOptionPlan').value)
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productBuyATC").classList.remove("loading");

        // open cart
        await openCart();
    }

    section.querySelector('.productBuyATC').addEventListener("click", addToCart);

    /**************
     Notify Me
     ***************/

    function bindNotifyForm() {
        const notifyForm = section.querySelector(".productNotifyForm");
        if (!notifyForm) return;

        notifyForm.addEventListener("submit", async function (e) {
            e.preventDefault();

            await sendKlaviyoBackInStockRequest(
                notifyForm.querySelector('input[name="email"]').value,
                activeVariant.id
            );

            notifiedVariants.add(activeVariant.id);
            const comingSoon = section.querySelector(`.productVisual[data-id="${activeVariant.id}"]`)?.dataset.comingSoon === 'true';
            section.querySelector(".productNotify").innerHTML =
                '<p class="productNotifySuccess">We\'ll notify you when this product is ' + (comingSoon ? 'available!' : 'back in stock!') + '</p>';
        });
    }

    bindNotifyForm();
}());